import logger from '@vue-util/logger';
import $http from '@vue-util/http';

const END_POINT = '/xapi/loyalty/v1/starrewardsenrollment?_pageType=Home';

const oneClickEnroll = async () => {
  const params = JSON.stringify({
    loyalty: {
      starRewardsAutoEnrollEnabled: true,
    },
  });
  const headers = {
    'content-type': 'application/json',
  };
  const options = {
    headers,
    params,
  };
  try {
    const response = await $http.post(END_POINT, options);
    if (response.errors || response.Error) {
      throw new Error(response.errors ? response.errors.error[0].message : response.Error.message);
    }
    return response;
  } catch (error) {
    logger.error(error);
    return undefined;
  }
};

export default oneClickEnroll;
